<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box p-0">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img [src]="mainLogoSmall" alt="" class="w-41" />
          </span>
          <span class="logo-lg">
            <span class="env-dev-logo w-75 pe-4" [class.is-dev]="isDevEnv">
              <img [src]="mainLogo" alt="" class="w-100" />
            </span>
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img [src]="mainLogoSmall" alt="" class="w-41" />
          </span>
          <span class="logo-lg">
            <span class="env-dev-logo w-75" [class.is-dev]="isDevEnv">
              <img [src]="mainLogo" alt="" class="w-100" />
            </span>
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div *ngIf="isDevEnv" class="env-dev-strip">מערכת DEV לבדיקות</div>

    <div class="d-flex">
      <!-- back-office notifications: job / post / invoice waiting (admin-notifications.service.ts) -->
      <button
        *ngIf="notificationState !== 'unsupported'"
        type="button"
        class="btn header-item noti-icon admin-noti-toggle"
        [class.is-on]="notificationState === 'enabled'"
        [title]="
          (notificationState === 'enabled'
            ? 'adminNotificationsOn'
            : notificationState === 'denied'
              ? 'adminNotificationsBlocked'
              : 'adminNotificationsEnable') + '.value' | translate
        "
        (click)="enableNotifications()"
      >
        <i
          class="mdi font-size-22"
          [ngClass]="notificationState === 'enabled' ? 'mdi-bell-ring' : 'mdi-bell-off-outline'"
        ></i>
      </button>
      <div class="dropdown d-inline-block language-switch" ngbDropdown placement="bottom-right">
        <button
          type="button"
          class="btn header-item"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <img *ngIf="flagvalue !== undefined" src="{{ flagvalue }}" alt="Header Language" height="16" />
          <img *ngIf="flagvalue === undefined" src="{{ valueset }}" alt="Header Language" height="16" />
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a
            href="javascript:void(0);"
            class="dropdown-item notify-item"
            *ngFor="let item of listLang"
            (click)="setLanguage(item.text, item.lang, item.flag)"
            [ngClass]="{ active: cookieValue === item.lang }"
          >
            <img src="{{ item.flag }}" alt="user-image" class="me-1" height="18" width="25" />
            <span class="align-middle">{{ item.text }}</span>
          </a>
        </div>
      </div>
      <!-- Notification -->
      <!-- <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon"
          id="page-header-notifications-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <i-feather class="icon-sm" name="bell"></i-feather>
          <span class="noti-dot bg-danger"></span>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown"
          ngbDropdownMenu
        >
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h5 class="m-0 font-size-15">{{ 'notificationTitle.value' | translate }}</h5>
              </div>
              <div class="col-auto">
                <a href="javascript:void(0);" class="small"> {{ 'notificationViewAll.value' | translate }}</a>
              </div>
            </div>
          </div>
          <ngx-simplebar style="max-height: 250px">
            <h6 class="dropdown-header bg-light">{{ 'new.value' | translate }}</h6>
            <a href="" class="text-reset notification-item">
              <div class="d-flex border-bottom align-items-start">
                <div class="flex-shrink-0">
                  <img src="assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-sm" alt="user-pic" />
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">{{ 'firstNotificationTitle.value' | translate }}</h6>
                  <div class="text-muted">
                    <p class="mb-1 font-size-13">{{ 'firstNotificationText.value' | translate }}</p>
                    <p class="mb-0 font-size-10 text-uppercase fw-bold">
                      <i class="mdi mdi-clock-outline"></i> {{ 'firstNotificationTime.value' | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="" class="text-reset notification-item">
              <div class="d-flex border-bottom align-items-start">
                <div class="flex-shrink-0">
                  <div class="avatar-sm me-3">
                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                      <i class="uil-shopping-basket"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">{{ 'secondNotificationTitle.value' | translate }}</h6>
                  <div class="text-muted">
                    <p class="mb-1 font-size-13">{{ 'secondNotificationText.value' | translate }}</p>
                    <p class="mb-0 font-size-10 text-uppercase fw-bold">
                      <i class="mdi mdi-clock-outline"></i> {{ 'secondNotificationTime.value' | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <h6 class="dropdown-header bg-light">{{ 'earlier.value' | translate }}</h6>
            <a href="" class="text-reset notification-item">
              <div class="d-flex border-bottom align-items-start">
                <div class="flex-shrink-0">
                  <div class="avatar-sm me-3">
                    <span class="avatar-title bg-soft-success text-success rounded-circle font-size-16">
                      <i class="uil-truck"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">{{ 'thirdNotificationTitle.value' | translate }}</h6>
                  <div class="text-muted">
                    <p class="mb-1 font-size-13">{{ 'thirdNotificationText.value' | translate }}</p>
                    <p class="mb-0 font-size-10 text-uppercase fw-bold">
                      <i class="mdi mdi-clock-outline"></i> {{ 'thirdNotificationTime.value' | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </a>

            <a href="" class="text-reset notification-item">
              <div class="d-flex border-bottom align-items-start">
                <div class="flex-shrink-0">
                  <img src="assets/images/users/avatar-4.jpg" class="me-3 rounded-circle avatar-sm" alt="user-pic" />
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">{{ 'fourNotificationTitle.value' | translate }}</h6>
                  <div class="text-muted">
                    <p class="mb-1 font-size-13">{{ 'fourNotificationText.value' | translate }}</p>
                    <p class="mb-0 font-size-10 text-uppercase fw-bold">
                      <i class="mdi mdi-clock-outline"></i>{{ 'fourNotificationTime.value' | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar>
          <div class="p-2 border-top d-grid">
            <a class="btn btn-sm btn-link font-size-14 btn-block text-center" href="javascript:void(0)">
              <i class="uil-arrow-circle-right me-1"></i>
              <span>{{ 'loadMore.value' | translate }}</span>
            </a>
          </div>
        </div>
      </div> -->

      <div class="dropdown d-inline-block">
        <button
          type="button"
          class="btn header-item noti-icon right-bar-toggle"
          id="right-bar-toggle"
          (click)="toggleRightSidebar()"
        >
          <i-feather class="icon-sm" name="settings"></i-feather>
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item user text-start d-flex align-items-center"
          id="page-header-user-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <img
            class="rounded-circle header-profile-user image-contain"
            [src]="'assets/images/nirlatLogo.png'"
            alt="Header Avatar"
          />
          <span class="ms-2 d-none d-sm-block user-item-desc">
            <span class="user-name">{{ _currentUser.firstName }} {{ _currentUser.lastName }} </span>
            <span class="user-sub-title"> {{ _currentUser.adminTypeName | titlecase }} </span>
          </span>
        </button>
        <div class="dropdown-menu dropdown-menu-bottom dropdown-menu-end pt-0" ngbDropdownMenu>
          <div class="p-3 bg-primary border-bottom">
            <h6 class="mb-0 text-white">{{ _currentUser.firstName }} {{ _currentUser.lastName }}</h6>
            <p class="mb-0 font-size-11 text-white-50 fw-semibold">{{ _currentUser.email }}</p>
          </div>
          <!-- <a class="dropdown-item" routerLink="/pages/profile"
            ><i class="mdi mdi-account-circle text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Profile</span></a
          >
          <a class="dropdown-item" routerLink="/chat"
            ><i class="mdi mdi-message-text-outline text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Messages</span></a
          >
          <a class="dropdown-item" routerLink="/kanban-board"
            ><i class="mdi mdi-calendar-check-outline text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Taskboard</span></a
          >
          <a class="dropdown-item" routerLink="/pages/faqs"
            ><i class="mdi mdi-lifebuoy text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Help</span></a
          >
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" routerLink="/pages/profile"
            ><i class="mdi mdi-wallet text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Balance : <b>$6951.02</b></span></a
          >
          <a class="dropdown-item d-flex align-items-center" routerLink="/contacts/settings"
            ><i class="mdi mdi-cog-outline text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Settings</span><span class="badge badge-soft-success ms-auto">New</span></a
          >
          <a class="dropdown-item" routerLink="/account/lockscreen/basic"
            ><i class="mdi mdi-lock text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Lock screen</span></a
          > -->
          <a class="dropdown-item" href="javascript: void(0);" (click)="logout()"
            ><i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">{{ 'logout.value' | translate }}</span></a
          >
        </div>
      </div>
    </div>
  </div>
</header>
